import React, { useState, useEffect } from 'react';
import { FaTimes, FaArrowUp, FaArrowDown, FaPlus, FaTrash, FaCheck } from 'react-icons/fa';
import { getImoveis } from '../services/api';
import './EditarImoveisModal.css';

const EditarImoveisModal = ({ isOpen, onClose, imoveisList, onSave }) => {
  const [imoveis, setImoveis] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [todosImoveis, setTodosImoveis] = useState([]);
  const [imoveisSelecionados, setImoveisSelecionados] = useState([]);
  const [pesquisaAdicionar, setPesquisaAdicionar] = useState('');

  useEffect(() => {
    if (isOpen) {
      setImoveis([...imoveisList]);
      loadTodosImoveis();
    }
  }, [isOpen, imoveisList]);

  const loadTodosImoveis = async () => {
    try {
      const response = await getImoveis({});
      setTodosImoveis(response.data);
    } catch (error) {
      console.error('Erro ao carregar todos os imóveis:', error);
    }
  };

  const handleMoveUp = (index) => {
    if (index === 0) return;
    const newImoveis = [...imoveis];
    [newImoveis[index - 1], newImoveis[index]] = [newImoveis[index], newImoveis[index - 1]];
    setImoveis(newImoveis);
  };

  const handleMoveDown = (index) => {
    if (index === imoveis.length - 1) return;
    const newImoveis = [...imoveis];
    [newImoveis[index], newImoveis[index + 1]] = [newImoveis[index + 1], newImoveis[index]];
    setImoveis(newImoveis);
  };

  const handleRemove = (index) => {
    const newImoveis = imoveis.filter((_, i) => i !== index);
    setImoveis(newImoveis);
  };

  const toggleSelecionarImovel = (imovelId) => {
    setImoveisSelecionados(prev => {
      if (prev.includes(imovelId)) {
        return prev.filter(id => id !== imovelId);
      } else {
        return [...prev, imovelId];
      }
    });
  };

  const handleAdicionarSelecionados = () => {
    const novosImoveis = todosImoveis.filter(imovel => 
      imoveisSelecionados.includes(imovel.id) && 
      !imoveis.some(i => i.id === imovel.id)
    );
    setImoveis([...imoveis, ...novosImoveis]);
    setImoveisSelecionados([]);
    setShowAddModal(false);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      // Salvar ordem dos imóveis (pode ser implementado com um campo 'ordem' no backend)
      // Por enquanto, apenas fechar o modal
      onSave(imoveis);
      onClose();
    } catch (error) {
      console.error('Erro ao salvar ordem:', error);
      alert('Erro ao salvar ordem');
    } finally {
      setLoading(false);
    }
  };

  const imoveisFiltrados = imoveis.filter(imovel => {
    if (!pesquisa) return true;
    const pesquisaLower = pesquisa.toLowerCase();
    return (
      imovel.codigo?.toLowerCase().includes(pesquisaLower) ||
      imovel.tipo?.toLowerCase().includes(pesquisaLower) ||
      imovel.bairro?.toLowerCase().includes(pesquisaLower) ||
      imovel.cidade?.toLowerCase().includes(pesquisaLower)
    );
  });

  if (!isOpen) return null;

  return (
    <>
      <div className="editar-imoveis-modal-overlay" onClick={onClose}>
        <div className="editar-imoveis-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h2>Editar e Ordenar Imóveis</h2>
            <button className="btn-close" onClick={onClose}><FaTimes /></button>
          </div>

          <div className="modal-body">
            <div className="actions-bar">
              <div className="search-box">
                <input
                  type="text"
                  placeholder="Pesquisar imóveis..."
                  value={pesquisa}
                  onChange={(e) => setPesquisa(e.target.value)}
                />
              </div>
              <button 
                className="btn-add-imovel" 
                onClick={() => setShowAddModal(true)}
              >
                <FaPlus /> Adicionar Imóvel
              </button>
            </div>

            {loading ? (
              <div className="loading">Carregando...</div>
            ) : (
              <div className="imoveis-list">
                {imoveisFiltrados.length === 0 ? (
                  <p>Nenhum imóvel encontrado</p>
                ) : (
                  imoveisFiltrados.map((imovel, index) => {
                    const originalIndex = imoveis.findIndex(i => i.id === imovel.id);
                    return (
                      <div key={imovel.id} className="imovel-item">
                        <div className="imovel-order">
                          <button
                            onClick={() => handleMoveUp(originalIndex)}
                            disabled={originalIndex === 0}
                            className="btn-order"
                            title="Mover para cima"
                          >
                            <FaArrowUp />
                          </button>
                          <span className="order-number">{originalIndex + 1}</span>
                          <button
                            onClick={() => handleMoveDown(originalIndex)}
                            disabled={originalIndex === imoveis.length - 1}
                            className="btn-order"
                            title="Mover para baixo"
                          >
                            <FaArrowDown />
                          </button>
                        </div>
                        <div className="imovel-info">
                          <strong>{imovel.codigo}</strong> - {imovel.tipo}
                          <br />
                          <small>{imovel.bairro}, {imovel.cidade}</small>
                        </div>
                        <button
                          onClick={() => handleRemove(originalIndex)}
                          className="btn-remove"
                          title="Remover da lista"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    );
                  })
                )}
              </div>
            )}
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>Cancelar</button>
            <button type="button" className="btn-save" onClick={handleSave} disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </div>
      </div>

      {/* Modal de Adicionar Imóveis Cadastrados */}
      {showAddModal && (
        <div className="add-imovel-modal-overlay" onClick={() => {
          setShowAddModal(false);
          setImoveisSelecionados([]);
          setPesquisaAdicionar('');
        }}>
          <div className="add-imovel-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Adicionar Imóveis Cadastrados</h3>
              <button className="btn-close" onClick={() => {
                setShowAddModal(false);
                setImoveisSelecionados([]);
                setPesquisaAdicionar('');
              }}><FaTimes /></button>
            </div>
            <div className="modal-body">
              <div className="search-box">
                <input
                  type="text"
                  placeholder="Pesquisar imóveis por código, tipo, bairro ou cidade..."
                  value={pesquisaAdicionar}
                  onChange={(e) => setPesquisaAdicionar(e.target.value)}
                />
              </div>

              <div className="imoveis-list" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                {todosImoveis
                  .filter(imovel => {
                    // Filtrar apenas imóveis que não estão na lista atual
                    if (imoveis.some(i => i.id === imovel.id)) return false;
                    
                    // Filtrar por pesquisa
                    if (!pesquisaAdicionar) return true;
                    const pesquisaLower = pesquisaAdicionar.toLowerCase();
                    return (
                      imovel.codigo?.toLowerCase().includes(pesquisaLower) ||
                      imovel.tipo?.toLowerCase().includes(pesquisaLower) ||
                      imovel.bairro?.toLowerCase().includes(pesquisaLower) ||
                      imovel.cidade?.toLowerCase().includes(pesquisaLower)
                    );
                  })
                  .map(imovel => (
                    <div 
                      key={imovel.id} 
                      className={`imovel-item ${imoveisSelecionados.includes(imovel.id) ? 'destaque' : ''}`}
                      onClick={() => toggleSelecionarImovel(imovel.id)}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="imovel-checkbox">
                        {imoveisSelecionados.includes(imovel.id) && <FaCheck />}
                      </div>
                      <div className="imovel-info">
                        <strong>{imovel.codigo}</strong> - {imovel.tipo}
                        <br />
                        <small>{imovel.bairro}, {imovel.cidade}</small>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className="modal-actions">
              <button 
                type="button" 
                className="btn-cancel" 
                onClick={() => {
                  setShowAddModal(false);
                  setImoveisSelecionados([]);
                  setPesquisaAdicionar('');
                }}
              >
                Cancelar
              </button>
              <button 
                type="button" 
                className="btn-save" 
                onClick={handleAdicionarSelecionados}
                disabled={imoveisSelecionados.length === 0}
              >
                Adicionar {imoveisSelecionados.length > 0 ? `(${imoveisSelecionados.length})` : ''}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EditarImoveisModal;

